import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { type ComboboxOption } from "@/components/Combobox/types";
import { graphql, type ResultOf } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";

type AnimalBreedId = string;

type Props = {
  id?: string;
  selected: Array<AnimalBreedId>;
  onSelect: (values: Array<AnimalBreedId>) => void;
  className?: string;
};

export type BreedsData = ResultOf<typeof supplyChainLotBreedsQuery>;

export function BreedsPicker({ id, selected, onSelect, className }: Props) {
  const { activeBusinessUnitId } = useActiveBusinessUnit();
  const { data, loading } = useQuery(supplyChainLotBreedsQuery, {
    variables: { businessUnit: activeBusinessUnitId },
  });

  const options: Array<ComboboxOption> = getBreedOptions(data);

  return (
    <Combobox
      id={id}
      name="breeds"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const getBreedOptions = (data: BreedsData | undefined) => {
  const breedOptions = removeNothings(data?.supplyChainLotBreeds?.edges || [])
    .filter((edge) => {
      return edge?.node.animalType?.id === "3";
    })
    .map((edge) => {
      return {
        label: edge.node.name,
        value: edge.node.id,
      };
    });

  return breedOptions;
};

export const supplyChainLotBreedsQuery = graphql(`
  query SupplyChainLotBreeds($businessUnit: ID) {
    supplyChainLotBreeds(businessUnit: $businessUnit) {
      edges {
        node {
          id
          name
          animalType {
            id
          }
        }
      }
    }
  }
`);
